import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import { FormRow } from 'src/components/Form';

const AddButton = styled(Svg)`
  width: 22px;

  circle {
    fill: var(--ph-light-blue-500);
  }
`;

const AddButtonLabel = styled('span')`
  position: relative;
  top: -5px;
  margin-left: 5px;
`;

const AddButtonWrapper = styled('div')`
  cursor: pointer;
  position: absolute;
  right: 30px;
  line-height: 0;
  z-index: 1;

  &.addFinding {
    position: static;
    display: inline-block;
    float: right;
  }

  &.inline {
    display: inline;
  }

  &.addNonCompliance {
    position: relative;
    margin-top: 15px;
    margin-bottom: 30px;
    right: 0;
    display: block;
    text-align: right;
    user-select: none;
    opacity: 1;
    transition: opacity 0.3s ease;
  }

  &.inactive {
    pointer-events: none;
    opacity: 0.3;
    filter: grayscale(1);
  }

`;

const AddNoteButtonWithTitleDiv = styled('div')`
  display: block;
  width: 100%;
  white-space: nowrap;
  align-items: center;
  justify-content: space-between;

  &.noFlex {
    display: block;
  }

  &.relative {
    position: relative;
  }
`;

const AlertNotification = styled('div')`
  margin-top: 15px;
  font-size: var(--ph-text-sm);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--alert-notification);
  display: flex;

  &.questionAlert {
    position: absolute;
    bottom: 1rem;
    right: 0;
  }
`;

const AlertNotificationBlock = styled('div')`
  > ul {
    padding-left: 30px;
    margin: 0;
  }
`;

const AlertNotificationIcon = styled(Svg)`
  width: 13px;
  margin-right: 5px;
`;

const BlockLabel = styled('div')`
  margin-top: 20px;
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);

  &.u-mt-60 {
    margin-top: 60px;
    position: relative;
    margin-bottom: 10px;
  }
`;

const Left = styled('div')`
  padding: 20px 20px 0 40px;
  background-color: var(--white);
  border-right: 1px solid var(--ph-gray-50);
  height: 100%;
`;

const MenuLink = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: var(--ph-gray-500);
  cursor: pointer;
  margin: 0 10px;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -5px;
    bottom: -5px;
    right: -10px;
    border-right: solid 1px rgba(var(--ph-gray-rgb-500), 0.2);
  }

  &:last-child::before {
    display: none;
  }

  &:first-child {
    margin-left: 0;
  }

  &.withIcon {
    margin-right: 30px;

    &::before {
      right: -25px;
    }
  }
`;

const MenuWrapper = styled('div')`
  margin: 5px 0 10px 0;
`;

const QuestionDescription = styled('div')`
  margin-top: 20px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: var(--ph-gray-500);
`;

const QuestionLabel = styled('div')`
  flex: 1;
  padding: 10px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  position: relative;
`;

const QuestionLabelText = styled('div')`
  white-space: pre-wrap;
`;

const QuestionNumber = styled('div')`
  flex: 0 0 60px;
  padding: 10px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionResultCompliant = styled('div')`
  color: var(--ph-green-500);
  fill: var(--ph-green-500);
`;

const QuestionResultIcon = styled(Svg)`
  width: 11px;
  margin-right: 5px;
`;

const QuestionResultLabel = styled('div')`
  margin: 0;
  font-size: var(--ph-text-sm);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const QuestionResultNA = styled('div')`
  color: var(--ph-gray-500);
  fill: var(--ph-gray-500);

  &.red {
    color: var(--ph-red-500);
    fill: var(--ph-red-500);
  }

  &.green {
    color: var(--ph-green-500);
    fill: var(--ph-green-500);
  }
`;

const QuestionResultNonCompliant = styled('div')`
  color: var(--ph-red-500);
  fill: var(--ph-red-500);
`;

const QuestionResultSelectCompliant = styled('div')`
  &.selected:hover {
    cursor: default;
    background-color: var(--ph-green-500);
  }

  &.selected {
    color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-green-500);
  }
`;

const QuestionResultSelectNA = styled('div')`
  &.selected:hover {
    cursor: default;
    background-color: var(--ph-gray-500);
  }

  &.selected {
    color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-500);
  }

  &.red {
    background-color: var(--ph-red-500);
  }

  &.green {
    background-color: var(--ph-green-500);
  }
`;

const QuestionResultSelectNonCompliant = styled('div')`
  &.selected:hover {
    cursor: default;
    background-color: var(--ph-red-500);
  }

  &.selected {
    color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-red-500);
  }
`;

const QuestionResultWrapper = styled('div')`
  margin: 20px 0 0;
  display: inline-flex;
  width: 100%;
  border: 1px solid var(--ph-gray-50);
  overflow-x: auto;

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% {
        box-shadow: 0 0 0 2px var(--ph-green-900);
      }
    }

    @keyframes fadeinout {
      50% {
        box-shadow: 0 0 0 2px var(--ph-green-900);
      }
    }
  }

  div {
    transition: var(--ph-transition);
    flex: 1;
    padding: 10px;
    border: 1px solid var(--ph-gray-50);
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--black);

    &:hover {
      background-color: var(--ph-gray-50);
    }

    &:last-child {
      border-right: 0;
    }
  }
`;

const QuestionResultDetails = styled(Svg)`
  width: 13px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  opacity: 0.3;

  &.red {
    width: 19px;
    opacity: 1;
    fill: var(--ph-red-500);
  }
`;

const QuestionText = styled('div')`
  margin-top: 10px;
  font-size: var(--ph-heading-three);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionTitle = styled('span')`
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
`;

const QuestionWrapper = styled('div')`
  display: flex;
  position: relative;
  cursor: pointer;
  border: 1px solid var(--ph-gray-50);

  &.selected {
    cursor: default;
    border-radius: var(--ph-border-radius-sm);
    background-color: rgba(var(--ph-gray-rgb-50), 0.2);
    border: 2px solid var(--ph-light-blue-500);
  }

  &.color-green {
    background-color: var(--ph-green-500);
  }

  &.color-blue {
    background-color: var(--ph-light-blue-500);
  }
`;

const QuickJumpIcon = styled(Svg)`
  width: 15px;
  position: absolute;
  right: -18px;
  top: -1px;
  fill: var(--ph-gray-500);
`;

const Right = styled('div')`
  padding: 20px;
  background-color: rgba(var(--ph-gray-rgb-50), 0.2);
  height: 100%;

  &.isSticky {
    max-height: 100vh;
    overflow: auto;
  }

  span[class*='leftMost'] {
    position: static;
  }

  &.readOnly *{
    color: var(--ph-gray-200);
    pointer-events: none;
  }
`;

const SectionsWrapper = styled('div')`
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 15px;
  margin-left: -15px;

  &.readOnly *{
    color: var(--ph-gray-200);
    pointer-events: none;
  }
`;

const SectionLabel = styled('div')`
  flex: 1;
  padding: 10px;
  position: relative;
`;

const SectionNumber = styled('div')`
  flex: 0 0 60px;
  padding: 10px;
`;

const SectionTitle = styled('div')`
  background-color: var(--ph-gray-500);
  display: flex;
  font-size: var(--ph-text-md);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  border-bottom: solid 1px #bbb5b1;
  cursor: pointer;
`;

const SectionToggleBtn = styled(Svg)`
  width: 15px;
  fill: var(--white);
  position: absolute;
  right: 10px;
  top: 12px;

  &.collapsed {
    transform: rotate(-90deg);
  }
`;

const SectionWrapper = styled('div')`
  position: relative;

  &.level2,
  & + & {
    border-top: 1px solid var(--ph-gray-500);
    border-radius: var(--ph-border-radius-sm);
  }

  &.root + &.root {
    margin-top: 30px;
  }

  &.collapsed + & {
    margin-top: 0 !important;
  }

  &.root > div[class*='SectionTitle'] {
    background-color: var(--ph-gray-500);
    font-size: var(--ph-text-sm);
    border-radius: var(--ph-border-radius-sm);
    margin-bottom: 5px;
  }
`;

const BlockFollowUp = styled('div')`
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0%, -50%);
  cursor: pointer;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: var(--ph-gray-500);
`;

const ToggleBlock = styled(Svg)`
  width: 15px;
  left: 10px;
  top: 2px;

  &.collapsed {
    transform: rotate(-90deg);
    top: 0;
  }
`;

const Title = styled('h1')`
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  margin-top: 0;
  margin-bottom: 0;
`;

const GreySwitchButton = styled('span')`
  width: 67px;
  height: 26px;
  border-radius: var(--ph-border-radius-sm);
  background-color: #f2f2f2;
  color: #66605c;
  font-size: var(--ph-text-sm);
  padding: 2px 9px 2px 9px;
  margin: 5px;
  cursor: pointer;

  &.selected {
    background-color: var(--ph-gray-500);
    color: var(--white);
  }

  &.small {
    font-size: var(--ph-text-sm);
  }
`;

const RedDot = styled('div')`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--ph-red-500);
  position: absolute;
  left: -15px;
  top: 15px;

  &.hide {
    display: none;
  }
`;

const NoQuestions = styled('div')`
  padding: 15px;
  border: var(--ph-gray-50) 1px solid;
  border-radius: var(--ph-border-radius-sm);
  color: rgba(var(--black-rgb), 0.2);
  z-index: 10;
  background: var(--white);
`;

const NoteExistedIcon = styled('span')`
  width: 105px;
  height: 22px;
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-gray-500);
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 10px;
  margin-right: 25px;

  &.actionRequired {
    color: var(--white);
    background-color: var(--ph-red-500);
  }
`;

const RemoveButton = styled(Svg)`
  width: 15px;
  position: absolute;
  right: -25px;
  top: 7px;
  z-index: 100;
  cursor: pointer;
  opacity: 0.3;

  &:hover {
    opacity: 1;
  }
`;

const NonComplianceWrapper = styled(FormRow)`
  position: relative;
  width: calc(100% - 60px);
  margin-left: 30px;

  & > span {
    display: block;
    position: absolute;
    left: -30px;
    top: 5px;
    width: 30px;
    color: var(--ph-gray-500);
  }

  &.error {
    box-shadow: 0 0 2px 2px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% {
        box-shadow: 0 0 0 2px var(--ph-green-900);
      }
    }

    @keyframes fadeinout {
      50% {
        box-shadow: 0 0 0 2px var(--ph-green-900);
      }
    }
  }
`;

const LawTitle = styled('span')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: var(--black);
`;

const LawSecNumber = styled('span')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: var(--ph-orange-500);
  margin-left: 15px;
`;

const LawDescription = styled('div')`
  margin: 5px 0 0 0;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: rgba(var(--black-rgb), 0.4);
  white-space: break-spaces;
`;

const LawMenuListFilter = styled('div')`
  border-bottom: solid 1px rgba(var(--ph-gray-rgb-500), 0.2);
  padding: 10px 15px;

  label {
    margin: 0;
  }
`;

const PopupWrapper = styled('div')`
  position: fixed;
  right: 10px;
  top: 50px;
  z-index: 99999;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  background-color: var(--white);
  padding: 35px 15px;
  width: 100px;
  height: 100px;
  max-height: 450px;
`;

const PopupTitle = styled('div')`
  font-size: var(--ph-heading-three);
  font-weight: 400;
  color: var(--black);
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
`;

const AlertText = styled('span')`
  font-weight: bold;
  display: inline-block;
`;

const QuickBtn = styled('div')`
  position: absolute;
  top: 10px;
  right: 35px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: underline;
  user-select: none;

  &:hover {
    opacity: 0.7;
    text-decoration: none;
  }
`;

const BlueLabel = styled('span')`
  height: 22px;
  border-radius: var(--ph-border-radius-sm);
  background-color: #99d9ea;
  color: #ffffff;
  font-size: var(--ph-text-sm);
  padding: 0px 9px;
  margin: 5px 25px 5px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default {
  AddButton,
  AddButtonLabel,
  AddButtonWrapper,
  AddNoteButtonWithTitleDiv,
  AlertNotification,
  AlertNotificationBlock,
  AlertNotificationIcon,
  AlertText,
  BlockFollowUp,
  BlockLabel,
  GreySwitchButton,
  LawDescription,
  LawMenuListFilter,
  LawSecNumber,
  LawTitle,
  Left,
  MenuLink,
  MenuWrapper,
  NoQuestions,
  NonComplianceWrapper,
  NoteExistedIcon,
  PopupTitle,
  PopupWrapper,
  QuestionDescription,
  QuestionLabel,
  QuestionLabelText,
  QuestionNumber,
  QuestionResultCompliant,
  QuestionResultDetails,
  QuestionResultIcon,
  QuestionResultLabel,
  QuestionResultNA,
  QuestionResultNonCompliant,
  QuestionResultSelectCompliant,
  QuestionResultSelectNA,
  QuestionResultSelectNonCompliant,
  QuestionResultWrapper,
  QuestionText,
  QuestionTitle,
  QuestionWrapper,
  QuickJumpIcon,
  RedDot,
  RemoveButton,
  Right,
  SectionLabel,
  SectionNumber,
  SectionTitle,
  SectionToggleBtn,
  SectionWrapper,
  SectionsWrapper,
  Title,
  ToggleBlock,
  QuickBtn,
  BlueLabel,
};
